// extracted by mini-css-extract-plugin
export var container = "product-pc-module--container--d45b4";
export var csIcon = "product-pc-module--cs-icon--18c95";
export var csWrap = "product-pc-module--cs-wrap--abf7b";
export var floatingDownload = "product-pc-module--floating-download--1a3b4";
export var info = "product-pc-module--info--f836e";
export var qrCode = "product-pc-module--qr-code--7f155";
export var qrCodeWrap = "product-pc-module--qr-code-wrap--88482";
export var qrIcon = "product-pc-module--qr-icon--7727c";
export var topIcon = "product-pc-module--top-icon--f35b0";